module.exports = __webpack_public_path__ + "assets/avatar-ebd686.svg";